// extracted by mini-css-extract-plugin
export default {"wrapper":"RolesDetailsPage_wrapper__aT3kC","content":"RolesDetailsPage_content__CngId","actions":"RolesDetailsPage_actions__3dgzs","list":"RolesDetailsPage_list__qFMz6"};